import type { ViewProps } from 'react-native'
import * as S from './price.styles'

export type PriceProps = {
  type?: 'default' | 'no-stock' | 'availability'
  fromItemsCondition?: string
  price?: string
  oldPrice?: string
  oldPriceTextDecoration?: 'line-through' | 'default'
  variantPrice?: string
} & Omit<ViewProps, 'style'>

const Price = ({
  price,
  oldPrice,
  oldPriceTextDecoration = 'line-through',
  variantPrice,
  fromItemsCondition,
  type = 'default',
  ...rest
}: PriceProps) => {
  if (type === 'availability') {
    return (
      <>
        <S.NoPriceContainer {...rest}>
          <S.AvailabilityText>Consulte a disponibilidade</S.AvailabilityText>
        </S.NoPriceContainer>
        {price && <S.ValueText numberOfLines={1}>{price}</S.ValueText>}
      </>
    )
  }

  if (type === 'no-stock') {
    return (
      <S.NoPriceContainer {...rest}>
        <S.OutOfStockText>Sem estoque</S.OutOfStockText>
        <S.NoticeWhenAvailableText>
          Receber aviso quando disponível?
        </S.NoticeWhenAvailableText>
      </S.NoPriceContainer>
    )
  }

  return (
    <S.PriceContainer {...rest}>
      {oldPrice && (
        <S.OldValueText
          numberOfLines={1}
          style={
            oldPriceTextDecoration === 'line-through'
              ? { textDecorationLine: 'line-through' }
              : {}
          }
        >
          {oldPrice}
        </S.OldValueText>
      )}
      {fromItemsCondition && (
        <S.OldValueText numberOfLines={1}>{fromItemsCondition}</S.OldValueText>
      )}
      <S.ValueText numberOfLines={1}>{price}</S.ValueText>
      {variantPrice && (
        <S.OldValueText numberOfLines={1}>{variantPrice}</S.OldValueText>
      )}
    </S.PriceContainer>
  )
}

export { Price }
